import { Wrapper } from './Styled'

export default function Info({ id, style, message, options, close }) {
  return <Wrapper>{message}</Wrapper>
}
